import { useCallback, useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router-dom';

import {
    commitVersionAndReload,
    fetchDeployedVersion,
    getStoredAppVersion,
    refreshDocumentCache,
    storeAppVersion,
} from '@app/helpers/AppVersionHelper';

const CacheBusting = ({ children }) => {
    const history = useHistory();
    const dispatch = useDispatch();

    const updateLastestVersion = useCallback(async () => {
        const deployedVersion = await fetchDeployedVersion().catch(() => null);
        const storedVersion = getStoredAppVersion();

        if (!deployedVersion || deployedVersion === storedVersion) {
            return;
        }

        if (!storedVersion) {
            storeAppVersion(deployedVersion);
            return;
        }

        if (!(await refreshDocumentCache())) {
            return;
        }

        dispatch({ type: 'RESET_STATE_VERSION_CHANGED' });
        commitVersionAndReload(deployedVersion);
    }, [dispatch]);

    useEffect(() => {
        const unlisten = history.listen(() => {
            updateLastestVersion();
        });

        return () => {
            unlisten();
        };
    }, [history, updateLastestVersion]);

    useEffect(() => {
        updateLastestVersion();
    }, [updateLastestVersion]);

    return children;
};

export default CacheBusting;
